(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    const prefillPodiumEnquiry = (root = document) => {
    const productTitle = new URLSearchParams(window.location.search).get('product');
    if (!productTitle) return;
    const title = productTitle.replace(/[\u0000-\u001f\u007f]/g, ' ').trim().slice(0, 200);
    if (!title) return;
    root.querySelectorAll('[data-podium-enquiry]').forEach((container) => {
      const subject = container.querySelector('[data-enquiry-title]');
      const message = container.closest('form')?.querySelector('[data-enquiry-body]');
      if (subject && !subject.value.trim()) subject.value = title;
      if (message && !message.value.trim()) {
        message.value = `${message.dataset.enquiryIntro} ${title}.\n\n${message.dataset.enquiryDetails}`;
      }
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => prefillPodiumEnquiry(), { once: true });
  } else {
    prefillPodiumEnquiry();
  }
  document.addEventListener('shopify:section:load', (event) => prefillPodiumEnquiry(event.target));
  } catch(e) { console.error(e); }
})();

})();
